/**
 * Copies the specified text to the clipboard.
 *
 * @param {string} textToCopy - The text to be copied to the clipboard.
 * @param {string} [type] - Optional MIME type for the clipboard data (e.g., 'text/plain', 'text/html').
 * @returns {Promise<void>} - A promise that resolves when the text is successfully copied to the clipboard.
 */
export async function copyToClipboard(textToCopy: string, type?: string): Promise<void> {
  if (navigator.clipboard && window.isSecureContext) {
    if (type && type !== 'text/plain') {
      /* According to experience, chrome seems to support text/html. */
      return navigator.clipboard.write([
        new ClipboardItem({
          [type]: new Blob([textToCopy], { type }),
          'text/plain': new Blob([textToCopy], { type: 'text/plain' })
        })
      ])
    } else {
      return navigator.clipboard.write([
        new ClipboardItem({
          'text/plain': new Blob([textToCopy], { type: 'text/plain' })
        })
      ])
    }
  } else {
    let textArea = document.createElement('textarea')

    textArea.value = textToCopy
    textArea.style.position = 'fixed'
    textArea.style.left = '-999999px'
    textArea.style.top = '-999999px'
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    return new Promise((res, rej) => {
      document.execCommand('copy') ? res() : rej()
      textArea.remove()
    })
  }
}
